import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";

export const TextArea = ({ errors, item, props, register, refObject }) => {
  const { getTextByKey } = useContent();

  return (
    <label className={`${errors[item.fieldKey] ? "invalid-input" : ""} `}>
      <div className={`input-label ${props?.label}`}>
        {getTextByKey(item.label)}
      </div>
      <textarea
        className={`textarea-field ${props?.field}`}
        type={item.element}
        placeholder={getTextByKey(item.placeholder)}
        {...register(item.fieldKey, refObject)}
      />
    </label>
  );
};

export const DefaultInput = ({
  errors,
  item,
  props,
  register,
  refObject,
  getValues,
}) => {
  const { getTextByKey, getDirection } = useContent();

  const autoFocus = () => {
    switch (item.title) {
      case "FirstName":
        return "given-name";
      case "LastName":
        return "family-name";
      case "Email":
        return "email";
      case "Phone":
        return "tel";
      case "Address":
        return "street-address";
      default:
        return item.title;
    }
  };

  const field = register(item.fieldKey, { ...refObject });
  const maxLength = item.validation?.maxLength;

  return (
    <label
      className={`${
        errors[item.fieldKey] ? "invalid-input" : ""
      } input-label-wrap`}
    >
      <div className={`input-label ${props?.label}`}>
        {getTextByKey(item.label)}
      </div>
      <input
        dir={getDirection()}
        className={`input-field ${props?.field} ${
          maxLength ? "input-field-with-max-length" : ""
        }`}
        type={item.type}
        placeholder={getTextByKey(item.placeholder)}
        autoComplete={autoFocus()}
        disabled={item.disabled}
        {...field}
        onChange={(e) => {
          e.target.value = item.filter
            ? item.filter(e.target.value)
            : e.target.value;
          field.onChange(e);
        }}
        autoFocus={item.autoFocus}
        maxLength={maxLength}
      />
      {maxLength ? (
        <span className="input-field-max-length">
          {getValues(item.fieldKey)?.length}/{maxLength}
        </span>
      ) : null}
    </label>
  );
};

export const CheckBox = ({
  errors,
  item,
  props,
  register,
  refObject,
  getValues,
}) => {
  const { getTextByKey } = useContent();
  return (
    <label
      className={`checkbox-container ${item.className || ""} ${
        errors[item.fieldKey] ? "invalid-input" : ""
      }`}
    >
      <input
        className={`input-field ${props?.field} ${
          getValues()[item.fieldKey] ? "changed" : "not"
        }`}
        type={item.element}
        placeholder={getTextByKey(item.placeholder)}
        {...register(item.fieldKey, refObject)}
      />
      <Image
        name={
          getValues()[item.fieldKey] ? "checkbox-checked" : "checkbox-unchecked"
        }
      />
      <div className="input-label">
        {item.customTitleElement
          ? item.customTitleElement()
          : getTextByKey(item?.label)}
      </div>
    </label>
  );
};
